import { UserClaims } from "@converge-collective/common/models/User";
import { useEffect, useState } from "react";
import { useUser } from "reactfire";
import firebase from "firebase/app";

export default function useUserClaims(): {
  claims: UserClaims | undefined;
  refreshClaims: () => Promise<void>;
} {
  const { data: user } = useUser();
  const [claims, setClaims] = useState<UserClaims>();

  const updateClaimsFromTokenResult = async () => {
    if (user) {
      console.log("getting user token result...", { user });
      const idTokenResult = await user.getIdTokenResult();
      console.log("got new id token, updated claims", {
        claims: idTokenResult.claims,
        user,
      });
      setClaims(idTokenResult.claims);
    }
  };

  const refreshClaims = async () => {
    if (user) {
      console.log("refreshing user claims...", { user, claims });
      await user.getIdToken(true);
      updateClaimsFromTokenResult();
    } else {
      console.warn("no user to refresh claims for");
    }
  };

  // automatically refresh claims when the user's id token changes
  useEffect(() => {
    firebase.auth().onIdTokenChanged(() => {
      updateClaimsFromTokenResult();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    refreshClaims();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return { claims, refreshClaims };
}
